import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '@/shared/i18n/i18n-provider';
import { StoreProvider } from '@/shared/store/store-provider';
import { ThemeProvider } from '@/shared/theme/theme-provider';
import { ThemeStyle } from '@/shared/theme/theme-style';
import { AppRoutes } from './router';
import { SessionBootstrap } from './session-bootstrap';

/**
 * Sağlayıcı sırası anlamlıdır:
 *  · `ThemeStyle`  — token değişkenleri belgeye basılır (kitin CSS modülleri
 *                    `var(--ib-*)` okur; önce onlar var olmalı).
 *  · `StoreProvider` — saga ve depo; `SessionBootstrap` onun İÇİNDE çalışır.
 *  · `I18nProvider`  — çevirmen bağlamı (kit metinlerini de besler).
 *  · `BrowserRouter` — yönlendirici; kapı ve kabuk onun altında.
 */
export function App() {
  return (
    <StoreProvider>
      <ThemeProvider>
        <I18nProvider>
          <ThemeStyle />
          <SessionBootstrap />
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </I18nProvider>
      </ThemeProvider>
    </StoreProvider>
  );
}
